/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  BurgerBoxConfigSaved,
  Category,
  CategoryWithTranslations,
  Coupon,
  CreateCategoryRequest,
  CreateCouponRequest,
  CreateDiscountPresetRequest,
  CreateProductRequest,
  DiscountPreset,
  DiscountSummary,
  GetBurgerBoxConfig200,
  GetCouponsParams,
  GetDiscountsStatsParams,
  GetPizzaIngredientsParams,
  GetProductsParams,
  GetRecipesParams,
  GetVatConfiguration200,
  GiftRule,
  GiftRuleDeleted,
  GiftRuleRequest,
  KitchenRecipe,
  LinkableProduct,
  PatchCouponsCouponIdBody,
  PatchPizzaIngredientsIngredientIdBody,
  PatchProductsProductIdBody,
  PatchSurchargesIdBody,
  PatchVatCategoriesIdBody,
  PizzaIngredient,
  PostPizzaIngredientsBody,
  PostSurchargesBody,
  PostVatCategoriesBody,
  Product,
  ProductCosts,
  ProductGiftRule,
  ProductGiftRuleRequest,
  ProductsBulkUpdated,
  PutBurgerBoxConfigBody,
  PutProductsBulkUpdateBodyItem,
  PutProductsProductIdSurchargesSurchargeIdBody,
  PutProductsProductIdVatCategoryBody,
  PutRecipesRecipeIdParams,
  Recipe,
  RecipeRequest,
  SetAddonsRequest,
  StockItemOption,
  Surcharge,
  SurchargeAttached,
  UpdateCategoryRequest,
  UpdateDiscountPresetRequest,
  UpdateGiftRuleRequest,
  UpdateProductGiftRuleRequest,
  ValidateCouponRequest,
  ValidatedCoupon,
  VatCategory,
  VatCategoryAssigned,
  VatCategoryDeleted,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getGetRecipesRecipeIdUrl = (recipeId: number) => {
  return `/api/v1/recipes/${recipeId}`
}

/**
 * @summary Read one recipe
 */
export const getRecipesRecipeId = async (
  recipeId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  return customFetch<Recipe>(getGetRecipesRecipeIdUrl(recipeId), {
    ...options,
    method: 'GET',
  })
}

export const getGetRecipesRecipeIdQueryKey = (recipeId: number) => {
  return [`/api/v1/recipes/${recipeId}`] as const
}

export const getGetRecipesRecipeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecipesRecipeId>>,
  TError = unknown,
>(
  recipeId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipesRecipeId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetRecipesRecipeIdQueryKey(recipeId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecipesRecipeId>>> = ({ signal }) =>
    getRecipesRecipeId(recipeId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: recipeId !== null && recipeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRecipesRecipeId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetRecipesRecipeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecipesRecipeId>>
>
export type GetRecipesRecipeIdQueryError = unknown

export function useGetRecipesRecipeId<
  TData = Awaited<ReturnType<typeof getRecipesRecipeId>>,
  TError = unknown,
>(
  recipeId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipesRecipeId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecipesRecipeId>>,
          TError,
          Awaited<ReturnType<typeof getRecipesRecipeId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecipesRecipeId<
  TData = Awaited<ReturnType<typeof getRecipesRecipeId>>,
  TError = unknown,
>(
  recipeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecipesRecipeId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecipesRecipeId>>,
          TError,
          Awaited<ReturnType<typeof getRecipesRecipeId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecipesRecipeId<
  TData = Awaited<ReturnType<typeof getRecipesRecipeId>>,
  TError = unknown,
>(
  recipeId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipesRecipeId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one recipe
 */

export function useGetRecipesRecipeId<
  TData = Awaited<ReturnType<typeof getRecipesRecipeId>>,
  TError = unknown,
>(
  recipeId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipesRecipeId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRecipesRecipeIdQueryOptions(recipeId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutRecipesRecipeIdUrl = (recipeId: number, params?: PutRecipesRecipeIdParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/recipes/${recipeId}?${stringifiedParams}`
    : `/api/v1/recipes/${recipeId}`
}

/**
 * @summary Replace a recipe and its ingredients
 */
export const putRecipesRecipeId = async (
  recipeId: number,
  recipeRequest: RecipeRequest,
  params?: PutRecipesRecipeIdParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  return customFetch<Recipe>(getPutRecipesRecipeIdUrl(recipeId, params), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recipeRequest),
  })
}

export const getPutRecipesRecipeIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putRecipesRecipeId>>,
    TError,
    { recipeId: number; data: RecipeRequest; params?: PutRecipesRecipeIdParams },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putRecipesRecipeId>>,
  TError,
  { recipeId: number; data: RecipeRequest; params?: PutRecipesRecipeIdParams },
  TContext
> => {
  const mutationKey = ['putRecipesRecipeId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putRecipesRecipeId>>,
    { recipeId: number; data: RecipeRequest; params?: PutRecipesRecipeIdParams }
  > = (props) => {
    const { recipeId, data, params } = props ?? {}

    return putRecipesRecipeId(recipeId, data, params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutRecipesRecipeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putRecipesRecipeId>>
>
export type PutRecipesRecipeIdMutationBody = RecipeRequest
export type PutRecipesRecipeIdMutationError = unknown

/**
 * @summary Replace a recipe and its ingredients
 */
export const usePutRecipesRecipeId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putRecipesRecipeId>>,
      TError,
      { recipeId: number; data: RecipeRequest; params?: PutRecipesRecipeIdParams },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putRecipesRecipeId>>,
  TError,
  { recipeId: number; data: RecipeRequest; params?: PutRecipesRecipeIdParams },
  TContext
> => {
  return useMutation(getPutRecipesRecipeIdMutationOptions(options), queryClient)
}
export const getDeleteRecipesRecipeIdUrl = (recipeId: number) => {
  return `/api/v1/recipes/${recipeId}`
}

/**
 * @summary Delete a recipe and its ingredients
 */
export const deleteRecipesRecipeId = async (
  recipeId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteRecipesRecipeIdUrl(recipeId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteRecipesRecipeIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRecipesRecipeId>>,
    TError,
    { recipeId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRecipesRecipeId>>,
  TError,
  { recipeId: number },
  TContext
> => {
  const mutationKey = ['deleteRecipesRecipeId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRecipesRecipeId>>,
    { recipeId: number }
  > = (props) => {
    const { recipeId } = props ?? {}

    return deleteRecipesRecipeId(recipeId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteRecipesRecipeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRecipesRecipeId>>
>

export type DeleteRecipesRecipeIdMutationError = unknown

/**
 * @summary Delete a recipe and its ingredients
 */
export const useDeleteRecipesRecipeId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRecipesRecipeId>>,
      TError,
      { recipeId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRecipesRecipeId>>,
  TError,
  { recipeId: number },
  TContext
> => {
  return useMutation(getDeleteRecipesRecipeIdMutationOptions(options), queryClient)
}
export const getPutProductsProductIdVatCategoryUrl = (productId: number) => {
  return `/api/v1/products/${productId}/vat-category`
}

/**
 * @summary Put a product in a VAT category, or back on the franchise default
 */
export const putProductsProductIdVatCategory = async (
  productId: number,
  putProductsProductIdVatCategoryBody: PutProductsProductIdVatCategoryBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<VatCategoryAssigned> => {
  return customFetch<VatCategoryAssigned>(getPutProductsProductIdVatCategoryUrl(productId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putProductsProductIdVatCategoryBody),
  })
}

export const getPutProductsProductIdVatCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProductsProductIdVatCategory>>,
    TError,
    { productId: number; data: PutProductsProductIdVatCategoryBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putProductsProductIdVatCategory>>,
  TError,
  { productId: number; data: PutProductsProductIdVatCategoryBody },
  TContext
> => {
  const mutationKey = ['putProductsProductIdVatCategory']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putProductsProductIdVatCategory>>,
    { productId: number; data: PutProductsProductIdVatCategoryBody }
  > = (props) => {
    const { productId, data } = props ?? {}

    return putProductsProductIdVatCategory(productId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutProductsProductIdVatCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof putProductsProductIdVatCategory>>
>
export type PutProductsProductIdVatCategoryMutationBody = PutProductsProductIdVatCategoryBody
export type PutProductsProductIdVatCategoryMutationError = unknown

/**
 * @summary Put a product in a VAT category, or back on the franchise default
 */
export const usePutProductsProductIdVatCategory = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProductsProductIdVatCategory>>,
      TError,
      { productId: number; data: PutProductsProductIdVatCategoryBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putProductsProductIdVatCategory>>,
  TError,
  { productId: number; data: PutProductsProductIdVatCategoryBody },
  TContext
> => {
  return useMutation(getPutProductsProductIdVatCategoryMutationOptions(options), queryClient)
}
export const getPutProductsProductIdSurchargesSurchargeIdUrl = (
  productId: number,
  surchargeId: number,
) => {
  return `/api/v1/products/${productId}/surcharges/${surchargeId}`
}

/**
 * @summary Attach a surcharge to a product, or take it off
 */
export const putProductsProductIdSurchargesSurchargeId = async (
  productId: number,
  surchargeId: number,
  putProductsProductIdSurchargesSurchargeIdBody?: PutProductsProductIdSurchargesSurchargeIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<SurchargeAttached> => {
  return customFetch<SurchargeAttached>(
    getPutProductsProductIdSurchargesSurchargeIdUrl(productId, surchargeId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(putProductsProductIdSurchargesSurchargeIdBody),
    },
  )
}

export const getPutProductsProductIdSurchargesSurchargeIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProductsProductIdSurchargesSurchargeId>>,
    TError,
    {
      productId: number
      surchargeId: number
      data?: PutProductsProductIdSurchargesSurchargeIdBody
    },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putProductsProductIdSurchargesSurchargeId>>,
  TError,
  { productId: number; surchargeId: number; data?: PutProductsProductIdSurchargesSurchargeIdBody },
  TContext
> => {
  const mutationKey = ['putProductsProductIdSurchargesSurchargeId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putProductsProductIdSurchargesSurchargeId>>,
    { productId: number; surchargeId: number; data?: PutProductsProductIdSurchargesSurchargeIdBody }
  > = (props) => {
    const { productId, surchargeId, data } = props ?? {}

    return putProductsProductIdSurchargesSurchargeId(productId, surchargeId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutProductsProductIdSurchargesSurchargeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putProductsProductIdSurchargesSurchargeId>>
>
export type PutProductsProductIdSurchargesSurchargeIdMutationBody =
  PutProductsProductIdSurchargesSurchargeIdBody | undefined
export type PutProductsProductIdSurchargesSurchargeIdMutationError = unknown

/**
 * @summary Attach a surcharge to a product, or take it off
 */
export const usePutProductsProductIdSurchargesSurchargeId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProductsProductIdSurchargesSurchargeId>>,
      TError,
      {
        productId: number
        surchargeId: number
        data?: PutProductsProductIdSurchargesSurchargeIdBody
      },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putProductsProductIdSurchargesSurchargeId>>,
  TError,
  { productId: number; surchargeId: number; data?: PutProductsProductIdSurchargesSurchargeIdBody },
  TContext
> => {
  return useMutation(
    getPutProductsProductIdSurchargesSurchargeIdMutationOptions(options),
    queryClient,
  )
}
export const getGetProductsProductIdAddonsUrl = (productId: number) => {
  return `/api/v1/products/${productId}/addons`
}

/**
 * @summary List the products offered as extras with this one (public)
 */
export const getProductsProductIdAddons = async (
  productId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Product[]> => {
  return customFetch<Product[]>(getGetProductsProductIdAddonsUrl(productId), {
    ...options,
    method: 'GET',
  })
}

export const getGetProductsProductIdAddonsQueryKey = (productId: number) => {
  return [`/api/v1/products/${productId}/addons`] as const
}

export const getGetProductsProductIdAddonsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductsProductIdAddons>>,
  TError = unknown,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductsProductIdAddons>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProductsProductIdAddonsQueryKey(productId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsProductIdAddons>>> = ({
    signal,
  }) => getProductsProductIdAddons(productId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: productId !== null && productId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProductsProductIdAddons>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetProductsProductIdAddonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductsProductIdAddons>>
>
export type GetProductsProductIdAddonsQueryError = unknown

export function useGetProductsProductIdAddons<
  TData = Awaited<ReturnType<typeof getProductsProductIdAddons>>,
  TError = unknown,
>(
  productId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductsProductIdAddons>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsProductIdAddons>>,
          TError,
          Awaited<ReturnType<typeof getProductsProductIdAddons>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsProductIdAddons<
  TData = Awaited<ReturnType<typeof getProductsProductIdAddons>>,
  TError = unknown,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductsProductIdAddons>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsProductIdAddons>>,
          TError,
          Awaited<ReturnType<typeof getProductsProductIdAddons>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsProductIdAddons<
  TData = Awaited<ReturnType<typeof getProductsProductIdAddons>>,
  TError = unknown,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductsProductIdAddons>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the products offered as extras with this one (public)
 */

export function useGetProductsProductIdAddons<
  TData = Awaited<ReturnType<typeof getProductsProductIdAddons>>,
  TError = unknown,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductsProductIdAddons>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProductsProductIdAddonsQueryOptions(productId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutProductsProductIdAddonsUrl = (productId: number) => {
  return `/api/v1/products/${productId}/addons`
}

/**
 * @summary Replace the extras offered with this product
 */
export const putProductsProductIdAddons = async (
  productId: number,
  setAddonsRequest: SetAddonsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Product[]> => {
  return customFetch<Product[]>(getPutProductsProductIdAddonsUrl(productId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setAddonsRequest),
  })
}

export const getPutProductsProductIdAddonsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProductsProductIdAddons>>,
    TError,
    { productId: number; data: SetAddonsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putProductsProductIdAddons>>,
  TError,
  { productId: number; data: SetAddonsRequest },
  TContext
> => {
  const mutationKey = ['putProductsProductIdAddons']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putProductsProductIdAddons>>,
    { productId: number; data: SetAddonsRequest }
  > = (props) => {
    const { productId, data } = props ?? {}

    return putProductsProductIdAddons(productId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutProductsProductIdAddonsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putProductsProductIdAddons>>
>
export type PutProductsProductIdAddonsMutationBody = SetAddonsRequest
export type PutProductsProductIdAddonsMutationError = unknown

/**
 * @summary Replace the extras offered with this product
 */
export const usePutProductsProductIdAddons = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProductsProductIdAddons>>,
      TError,
      { productId: number; data: SetAddonsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putProductsProductIdAddons>>,
  TError,
  { productId: number; data: SetAddonsRequest },
  TContext
> => {
  return useMutation(getPutProductsProductIdAddonsMutationOptions(options), queryClient)
}
export const getPutProductsBulkUpdateUrl = () => {
  return `/api/v1/products/bulk-update`
}

/**
 * @summary Apply a batch of product edits
 */
export const putProductsBulkUpdate = async (
  putProductsBulkUpdateBodyItem: PutProductsBulkUpdateBodyItem[],
  options?: Parameters<typeof customFetch>[1],
): Promise<ProductsBulkUpdated> => {
  return customFetch<ProductsBulkUpdated>(getPutProductsBulkUpdateUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putProductsBulkUpdateBodyItem),
  })
}

export const getPutProductsBulkUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProductsBulkUpdate>>,
    TError,
    { data: PutProductsBulkUpdateBodyItem[] },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putProductsBulkUpdate>>,
  TError,
  { data: PutProductsBulkUpdateBodyItem[] },
  TContext
> => {
  const mutationKey = ['putProductsBulkUpdate']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putProductsBulkUpdate>>,
    { data: PutProductsBulkUpdateBodyItem[] }
  > = (props) => {
    const { data } = props ?? {}

    return putProductsBulkUpdate(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutProductsBulkUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof putProductsBulkUpdate>>
>
export type PutProductsBulkUpdateMutationBody = PutProductsBulkUpdateBodyItem[]
export type PutProductsBulkUpdateMutationError = unknown

/**
 * @summary Apply a batch of product edits
 */
export const usePutProductsBulkUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProductsBulkUpdate>>,
      TError,
      { data: PutProductsBulkUpdateBodyItem[] },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putProductsBulkUpdate>>,
  TError,
  { data: PutProductsBulkUpdateBodyItem[] },
  TContext
> => {
  return useMutation(getPutProductsBulkUpdateMutationOptions(options), queryClient)
}
export const getGetBurgerBoxConfigUrl = () => {
  return `/api/v1/burger-box-config`
}

/**
 * @summary Read the burger-box configuration (public)
 */
export const getBurgerBoxConfig = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetBurgerBoxConfig200> => {
  return customFetch<GetBurgerBoxConfig200>(getGetBurgerBoxConfigUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetBurgerBoxConfigQueryKey = () => {
  return [`/api/v1/burger-box-config`] as const
}

export const getGetBurgerBoxConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getBurgerBoxConfig>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBurgerBoxConfig>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBurgerBoxConfigQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBurgerBoxConfig>>> = ({ signal }) =>
    getBurgerBoxConfig({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBurgerBoxConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBurgerBoxConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBurgerBoxConfig>>
>
export type GetBurgerBoxConfigQueryError = unknown

export function useGetBurgerBoxConfig<
  TData = Awaited<ReturnType<typeof getBurgerBoxConfig>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBurgerBoxConfig>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBurgerBoxConfig>>,
          TError,
          Awaited<ReturnType<typeof getBurgerBoxConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBurgerBoxConfig<
  TData = Awaited<ReturnType<typeof getBurgerBoxConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBurgerBoxConfig>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBurgerBoxConfig>>,
          TError,
          Awaited<ReturnType<typeof getBurgerBoxConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBurgerBoxConfig<
  TData = Awaited<ReturnType<typeof getBurgerBoxConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBurgerBoxConfig>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the burger-box configuration (public)
 */

export function useGetBurgerBoxConfig<
  TData = Awaited<ReturnType<typeof getBurgerBoxConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBurgerBoxConfig>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBurgerBoxConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutBurgerBoxConfigUrl = () => {
  return `/api/v1/burger-box-config`
}

/**
 * @summary Replace the burger-box configuration
 */
export const putBurgerBoxConfig = async (
  putBurgerBoxConfigBody: PutBurgerBoxConfigBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<BurgerBoxConfigSaved> => {
  return customFetch<BurgerBoxConfigSaved>(getPutBurgerBoxConfigUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putBurgerBoxConfigBody),
  })
}

export const getPutBurgerBoxConfigMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBurgerBoxConfig>>,
    TError,
    { data: PutBurgerBoxConfigBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBurgerBoxConfig>>,
  TError,
  { data: PutBurgerBoxConfigBody },
  TContext
> => {
  const mutationKey = ['putBurgerBoxConfig']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBurgerBoxConfig>>,
    { data: PutBurgerBoxConfigBody }
  > = (props) => {
    const { data } = props ?? {}

    return putBurgerBoxConfig(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutBurgerBoxConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBurgerBoxConfig>>
>
export type PutBurgerBoxConfigMutationBody = PutBurgerBoxConfigBody
export type PutBurgerBoxConfigMutationError = unknown

/**
 * @summary Replace the burger-box configuration
 */
export const usePutBurgerBoxConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putBurgerBoxConfig>>,
      TError,
      { data: PutBurgerBoxConfigBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putBurgerBoxConfig>>,
  TError,
  { data: PutBurgerBoxConfigBody },
  TContext
> => {
  return useMutation(getPutBurgerBoxConfigMutationOptions(options), queryClient)
}
export const getGetVatCategoriesUrl = () => {
  return `/api/v1/vat-categories`
}

/**
 * @summary The VAT rates this franchise charges
 */
export const getVatCategories = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<VatCategory[]> => {
  return customFetch<VatCategory[]>(getGetVatCategoriesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetVatCategoriesQueryKey = () => {
  return [`/api/v1/vat-categories`] as const
}

export const getGetVatCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getVatCategories>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVatCategories>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetVatCategoriesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatCategories>>> = ({ signal }) =>
    getVatCategories({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVatCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVatCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getVatCategories>>>
export type GetVatCategoriesQueryError = unknown

export function useGetVatCategories<
  TData = Awaited<ReturnType<typeof getVatCategories>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVatCategories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVatCategories>>,
          TError,
          Awaited<ReturnType<typeof getVatCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVatCategories<
  TData = Awaited<ReturnType<typeof getVatCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVatCategories>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVatCategories>>,
          TError,
          Awaited<ReturnType<typeof getVatCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVatCategories<
  TData = Awaited<ReturnType<typeof getVatCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVatCategories>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The VAT rates this franchise charges
 */

export function useGetVatCategories<
  TData = Awaited<ReturnType<typeof getVatCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVatCategories>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetVatCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostVatCategoriesUrl = () => {
  return `/api/v1/vat-categories`
}

/**
 * @summary Add a VAT category
 */
export const postVatCategories = async (
  postVatCategoriesBody: PostVatCategoriesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<VatCategory> => {
  return customFetch<VatCategory>(getPostVatCategoriesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postVatCategoriesBody),
  })
}

export const getPostVatCategoriesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postVatCategories>>,
    TError,
    { data: PostVatCategoriesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postVatCategories>>,
  TError,
  { data: PostVatCategoriesBody },
  TContext
> => {
  const mutationKey = ['postVatCategories']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postVatCategories>>,
    { data: PostVatCategoriesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postVatCategories(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostVatCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postVatCategories>>
>
export type PostVatCategoriesMutationBody = PostVatCategoriesBody
export type PostVatCategoriesMutationError = unknown

/**
 * @summary Add a VAT category
 */
export const usePostVatCategories = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postVatCategories>>,
      TError,
      { data: PostVatCategoriesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postVatCategories>>,
  TError,
  { data: PostVatCategoriesBody },
  TContext
> => {
  return useMutation(getPostVatCategoriesMutationOptions(options), queryClient)
}
export const getGetSurchargesUrl = () => {
  return `/api/v1/surcharges`
}

/**
 * @summary The surcharges and deposits this franchise charges
 */
export const getSurcharges = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Surcharge[]> => {
  return customFetch<Surcharge[]>(getGetSurchargesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSurchargesQueryKey = () => {
  return [`/api/v1/surcharges`] as const
}

export const getGetSurchargesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSurcharges>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurcharges>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSurchargesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurcharges>>> = ({ signal }) =>
    getSurcharges({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSurcharges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurchargesQueryResult = NonNullable<Awaited<ReturnType<typeof getSurcharges>>>
export type GetSurchargesQueryError = unknown

export function useGetSurcharges<
  TData = Awaited<ReturnType<typeof getSurcharges>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurcharges>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurcharges>>,
          TError,
          Awaited<ReturnType<typeof getSurcharges>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurcharges<
  TData = Awaited<ReturnType<typeof getSurcharges>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurcharges>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurcharges>>,
          TError,
          Awaited<ReturnType<typeof getSurcharges>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurcharges<
  TData = Awaited<ReturnType<typeof getSurcharges>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurcharges>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The surcharges and deposits this franchise charges
 */

export function useGetSurcharges<
  TData = Awaited<ReturnType<typeof getSurcharges>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurcharges>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSurchargesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSurchargesUrl = () => {
  return `/api/v1/surcharges`
}

/**
 * @summary Add a surcharge or deposit
 */
export const postSurcharges = async (
  postSurchargesBody: PostSurchargesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Surcharge> => {
  return customFetch<Surcharge>(getPostSurchargesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSurchargesBody),
  })
}

export const getPostSurchargesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSurcharges>>,
    TError,
    { data: PostSurchargesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSurcharges>>,
  TError,
  { data: PostSurchargesBody },
  TContext
> => {
  const mutationKey = ['postSurcharges']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSurcharges>>,
    { data: PostSurchargesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSurcharges(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSurchargesMutationResult = NonNullable<Awaited<ReturnType<typeof postSurcharges>>>
export type PostSurchargesMutationBody = PostSurchargesBody
export type PostSurchargesMutationError = unknown

/**
 * @summary Add a surcharge or deposit
 */
export const usePostSurcharges = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSurcharges>>,
      TError,
      { data: PostSurchargesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSurcharges>>,
  TError,
  { data: PostSurchargesBody },
  TContext
> => {
  return useMutation(getPostSurchargesMutationOptions(options), queryClient)
}
export const getGetRecipesUrl = (params?: GetRecipesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/v1/recipes?${stringifiedParams}` : `/api/v1/recipes`
}

/**
 * @summary List recipes, optionally one category
 */
export const getRecipes = async (
  params?: GetRecipesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe[]> => {
  return customFetch<Recipe[]>(getGetRecipesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetRecipesQueryKey = (params?: GetRecipesParams) => {
  return [`/api/v1/recipes`, ...(params ? [params] : [])] as const
}

export const getGetRecipesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecipes>>,
  TError = unknown,
>(
  params?: GetRecipesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipes>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetRecipesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecipes>>> = ({ signal }) =>
    getRecipes(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecipes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRecipesQueryResult = NonNullable<Awaited<ReturnType<typeof getRecipes>>>
export type GetRecipesQueryError = unknown

export function useGetRecipes<TData = Awaited<ReturnType<typeof getRecipes>>, TError = unknown>(
  params: undefined | GetRecipesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecipes>>,
          TError,
          Awaited<ReturnType<typeof getRecipes>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecipes<TData = Awaited<ReturnType<typeof getRecipes>>, TError = unknown>(
  params?: GetRecipesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecipes>>,
          TError,
          Awaited<ReturnType<typeof getRecipes>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecipes<TData = Awaited<ReturnType<typeof getRecipes>>, TError = unknown>(
  params?: GetRecipesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipes>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List recipes, optionally one category
 */

export function useGetRecipes<TData = Awaited<ReturnType<typeof getRecipes>>, TError = unknown>(
  params?: GetRecipesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecipes>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRecipesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostRecipesUrl = () => {
  return `/api/v1/recipes`
}

/**
 * @summary Create a recipe
 */
export const postRecipes = async (
  recipeRequest: RecipeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  return customFetch<Recipe>(getPostRecipesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recipeRequest),
  })
}

export const getPostRecipesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRecipes>>,
    TError,
    { data: RecipeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRecipes>>,
  TError,
  { data: RecipeRequest },
  TContext
> => {
  const mutationKey = ['postRecipes']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRecipes>>,
    { data: RecipeRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postRecipes(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostRecipesMutationResult = NonNullable<Awaited<ReturnType<typeof postRecipes>>>
export type PostRecipesMutationBody = RecipeRequest
export type PostRecipesMutationError = unknown

/**
 * @summary Create a recipe
 */
export const usePostRecipes = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRecipes>>,
      TError,
      { data: RecipeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRecipes>>,
  TError,
  { data: RecipeRequest },
  TContext
> => {
  return useMutation(getPostRecipesMutationOptions(options), queryClient)
}
export const getGetProductsUrl = (params?: GetProductsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/v1/products?${stringifiedParams}` : `/api/v1/products`
}

/**
 * @summary List the menu, optionally one category (public)
 */
export const getProducts = async (
  params?: GetProductsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Product[]> => {
  return customFetch<Product[]>(getGetProductsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetProductsQueryKey = (params?: GetProductsParams) => {
  return [`/api/v1/products`, ...(params ? [params] : [])] as const
}

export const getGetProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProducts>>,
  TError = unknown,
>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProductsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) =>
    getProducts(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsQueryError = unknown

export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
  params: undefined | GetProductsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the menu, optionally one category (public)
 */

export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
  params?: GetProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProductsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostProductsUrl = () => {
  return `/api/v1/products`
}

/**
 * @summary Create a product
 */
export const postProducts = async (
  createProductRequest: CreateProductRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Product> => {
  return customFetch<Product>(getPostProductsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProductRequest),
  })
}

export const getPostProductsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postProducts>>,
    TError,
    { data: CreateProductRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postProducts>>,
  TError,
  { data: CreateProductRequest },
  TContext
> => {
  const mutationKey = ['postProducts']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postProducts>>,
    { data: CreateProductRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postProducts(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostProductsMutationResult = NonNullable<Awaited<ReturnType<typeof postProducts>>>
export type PostProductsMutationBody = CreateProductRequest
export type PostProductsMutationError = unknown

/**
 * @summary Create a product
 */
export const usePostProducts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postProducts>>,
      TError,
      { data: CreateProductRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postProducts>>,
  TError,
  { data: CreateProductRequest },
  TContext
> => {
  return useMutation(getPostProductsMutationOptions(options), queryClient)
}
export const getGetPizzaIngredientsUrl = (params?: GetPizzaIngredientsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/pizza-ingredients?${stringifiedParams}`
    : `/api/v1/pizza-ingredients`
}

/**
 * @summary List pizza toppings (public)
 */
export const getPizzaIngredients = async (
  params?: GetPizzaIngredientsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PizzaIngredient[]> => {
  return customFetch<PizzaIngredient[]>(getGetPizzaIngredientsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetPizzaIngredientsQueryKey = (params?: GetPizzaIngredientsParams) => {
  return [`/api/v1/pizza-ingredients`, ...(params ? [params] : [])] as const
}

export const getGetPizzaIngredientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPizzaIngredients>>,
  TError = unknown,
>(
  params?: GetPizzaIngredientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPizzaIngredients>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPizzaIngredientsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPizzaIngredients>>> = ({ signal }) =>
    getPizzaIngredients(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPizzaIngredients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPizzaIngredientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPizzaIngredients>>
>
export type GetPizzaIngredientsQueryError = unknown

export function useGetPizzaIngredients<
  TData = Awaited<ReturnType<typeof getPizzaIngredients>>,
  TError = unknown,
>(
  params: undefined | GetPizzaIngredientsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaIngredients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPizzaIngredients>>,
          TError,
          Awaited<ReturnType<typeof getPizzaIngredients>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPizzaIngredients<
  TData = Awaited<ReturnType<typeof getPizzaIngredients>>,
  TError = unknown,
>(
  params?: GetPizzaIngredientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaIngredients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPizzaIngredients>>,
          TError,
          Awaited<ReturnType<typeof getPizzaIngredients>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPizzaIngredients<
  TData = Awaited<ReturnType<typeof getPizzaIngredients>>,
  TError = unknown,
>(
  params?: GetPizzaIngredientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPizzaIngredients>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List pizza toppings (public)
 */

export function useGetPizzaIngredients<
  TData = Awaited<ReturnType<typeof getPizzaIngredients>>,
  TError = unknown,
>(
  params?: GetPizzaIngredientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPizzaIngredients>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPizzaIngredientsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostPizzaIngredientsUrl = () => {
  return `/api/v1/pizza-ingredients`
}

/**
 * @summary Create a pizza topping
 */
export const postPizzaIngredients = async (
  postPizzaIngredientsBody: PostPizzaIngredientsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PizzaIngredient> => {
  return customFetch<PizzaIngredient>(getPostPizzaIngredientsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postPizzaIngredientsBody),
  })
}

export const getPostPizzaIngredientsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPizzaIngredients>>,
    TError,
    { data: PostPizzaIngredientsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPizzaIngredients>>,
  TError,
  { data: PostPizzaIngredientsBody },
  TContext
> => {
  const mutationKey = ['postPizzaIngredients']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPizzaIngredients>>,
    { data: PostPizzaIngredientsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postPizzaIngredients(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostPizzaIngredientsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPizzaIngredients>>
>
export type PostPizzaIngredientsMutationBody = PostPizzaIngredientsBody
export type PostPizzaIngredientsMutationError = unknown

/**
 * @summary Create a pizza topping
 */
export const usePostPizzaIngredients = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPizzaIngredients>>,
      TError,
      { data: PostPizzaIngredientsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPizzaIngredients>>,
  TError,
  { data: PostPizzaIngredientsBody },
  TContext
> => {
  return useMutation(getPostPizzaIngredientsMutationOptions(options), queryClient)
}
export const getGetGiftsRulesUrl = () => {
  return `/api/v1/gifts/rules`
}

/**
 * @summary List order-total gift rules
 */
export const getGiftsRules = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GiftRule[]> => {
  return customFetch<GiftRule[]>(getGetGiftsRulesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetGiftsRulesQueryKey = () => {
  return [`/api/v1/gifts/rules`] as const
}

export const getGetGiftsRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getGiftsRules>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGiftsRules>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetGiftsRulesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGiftsRules>>> = ({ signal }) =>
    getGiftsRules({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGiftsRules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGiftsRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getGiftsRules>>>
export type GetGiftsRulesQueryError = unknown

export function useGetGiftsRules<
  TData = Awaited<ReturnType<typeof getGiftsRules>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGiftsRules>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGiftsRules>>,
          TError,
          Awaited<ReturnType<typeof getGiftsRules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGiftsRules<
  TData = Awaited<ReturnType<typeof getGiftsRules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGiftsRules>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGiftsRules>>,
          TError,
          Awaited<ReturnType<typeof getGiftsRules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGiftsRules<
  TData = Awaited<ReturnType<typeof getGiftsRules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGiftsRules>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List order-total gift rules
 */

export function useGetGiftsRules<
  TData = Awaited<ReturnType<typeof getGiftsRules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGiftsRules>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGiftsRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostGiftsRulesUrl = () => {
  return `/api/v1/gifts/rules`
}

/**
 * @summary Create an order-total gift rule
 */
export const postGiftsRules = async (
  giftRuleRequest: GiftRuleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<GiftRule> => {
  return customFetch<GiftRule>(getPostGiftsRulesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(giftRuleRequest),
  })
}

export const getPostGiftsRulesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postGiftsRules>>,
    TError,
    { data: GiftRuleRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postGiftsRules>>,
  TError,
  { data: GiftRuleRequest },
  TContext
> => {
  const mutationKey = ['postGiftsRules']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postGiftsRules>>,
    { data: GiftRuleRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postGiftsRules(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostGiftsRulesMutationResult = NonNullable<Awaited<ReturnType<typeof postGiftsRules>>>
export type PostGiftsRulesMutationBody = GiftRuleRequest
export type PostGiftsRulesMutationError = unknown

/**
 * @summary Create an order-total gift rule
 */
export const usePostGiftsRules = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postGiftsRules>>,
      TError,
      { data: GiftRuleRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postGiftsRules>>,
  TError,
  { data: GiftRuleRequest },
  TContext
> => {
  return useMutation(getPostGiftsRulesMutationOptions(options), queryClient)
}
export const getGetGiftsProductRulesUrl = () => {
  return `/api/v1/gifts/product-rules`
}

/**
 * @summary List product gift rules
 */
export const getGiftsProductRules = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ProductGiftRule[]> => {
  return customFetch<ProductGiftRule[]>(getGetGiftsProductRulesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetGiftsProductRulesQueryKey = () => {
  return [`/api/v1/gifts/product-rules`] as const
}

export const getGetGiftsProductRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getGiftsProductRules>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRules>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetGiftsProductRulesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGiftsProductRules>>> = ({ signal }) =>
    getGiftsProductRules({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGiftsProductRules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGiftsProductRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGiftsProductRules>>
>
export type GetGiftsProductRulesQueryError = unknown

export function useGetGiftsProductRules<
  TData = Awaited<ReturnType<typeof getGiftsProductRules>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRules>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGiftsProductRules>>,
          TError,
          Awaited<ReturnType<typeof getGiftsProductRules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGiftsProductRules<
  TData = Awaited<ReturnType<typeof getGiftsProductRules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRules>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGiftsProductRules>>,
          TError,
          Awaited<ReturnType<typeof getGiftsProductRules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGiftsProductRules<
  TData = Awaited<ReturnType<typeof getGiftsProductRules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRules>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List product gift rules
 */

export function useGetGiftsProductRules<
  TData = Awaited<ReturnType<typeof getGiftsProductRules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRules>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGiftsProductRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostGiftsProductRulesUrl = () => {
  return `/api/v1/gifts/product-rules`
}

/**
 * @summary Create a product gift rule
 */
export const postGiftsProductRules = async (
  productGiftRuleRequest: ProductGiftRuleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<ProductGiftRule> => {
  return customFetch<ProductGiftRule>(getPostGiftsProductRulesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productGiftRuleRequest),
  })
}

export const getPostGiftsProductRulesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postGiftsProductRules>>,
    TError,
    { data: ProductGiftRuleRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postGiftsProductRules>>,
  TError,
  { data: ProductGiftRuleRequest },
  TContext
> => {
  const mutationKey = ['postGiftsProductRules']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postGiftsProductRules>>,
    { data: ProductGiftRuleRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postGiftsProductRules(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostGiftsProductRulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postGiftsProductRules>>
>
export type PostGiftsProductRulesMutationBody = ProductGiftRuleRequest
export type PostGiftsProductRulesMutationError = unknown

/**
 * @summary Create a product gift rule
 */
export const usePostGiftsProductRules = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postGiftsProductRules>>,
      TError,
      { data: ProductGiftRuleRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postGiftsProductRules>>,
  TError,
  { data: ProductGiftRuleRequest },
  TContext
> => {
  return useMutation(getPostGiftsProductRulesMutationOptions(options), queryClient)
}
export const getGetDiscountPresetsUrl = () => {
  return `/api/v1/discount-presets`
}

/**
 * @summary List manual discount presets
 */
export const getDiscountPresets = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DiscountPreset[]> => {
  return customFetch<DiscountPreset[]>(getGetDiscountPresetsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetDiscountPresetsQueryKey = () => {
  return [`/api/v1/discount-presets`] as const
}

export const getGetDiscountPresetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiscountPresets>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountPresets>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDiscountPresetsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscountPresets>>> = ({ signal }) =>
    getDiscountPresets({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiscountPresets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDiscountPresetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiscountPresets>>
>
export type GetDiscountPresetsQueryError = unknown

export function useGetDiscountPresets<
  TData = Awaited<ReturnType<typeof getDiscountPresets>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountPresets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscountPresets>>,
          TError,
          Awaited<ReturnType<typeof getDiscountPresets>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscountPresets<
  TData = Awaited<ReturnType<typeof getDiscountPresets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDiscountPresets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscountPresets>>,
          TError,
          Awaited<ReturnType<typeof getDiscountPresets>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscountPresets<
  TData = Awaited<ReturnType<typeof getDiscountPresets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountPresets>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List manual discount presets
 */

export function useGetDiscountPresets<
  TData = Awaited<ReturnType<typeof getDiscountPresets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountPresets>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDiscountPresetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostDiscountPresetsUrl = () => {
  return `/api/v1/discount-presets`
}

/**
 * @summary Create a manual discount preset
 */
export const postDiscountPresets = async (
  createDiscountPresetRequest: CreateDiscountPresetRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<DiscountPreset> => {
  return customFetch<DiscountPreset>(getPostDiscountPresetsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDiscountPresetRequest),
  })
}

export const getPostDiscountPresetsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDiscountPresets>>,
    TError,
    { data: CreateDiscountPresetRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDiscountPresets>>,
  TError,
  { data: CreateDiscountPresetRequest },
  TContext
> => {
  const mutationKey = ['postDiscountPresets']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDiscountPresets>>,
    { data: CreateDiscountPresetRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postDiscountPresets(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostDiscountPresetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDiscountPresets>>
>
export type PostDiscountPresetsMutationBody = CreateDiscountPresetRequest
export type PostDiscountPresetsMutationError = unknown

/**
 * @summary Create a manual discount preset
 */
export const usePostDiscountPresets = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDiscountPresets>>,
      TError,
      { data: CreateDiscountPresetRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDiscountPresets>>,
  TError,
  { data: CreateDiscountPresetRequest },
  TContext
> => {
  return useMutation(getPostDiscountPresetsMutationOptions(options), queryClient)
}
export const getGetCouponsUrl = (params?: GetCouponsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/v1/coupons?${stringifiedParams}` : `/api/v1/coupons`
}

/**
 * @summary List coupons, newest first
 */
export const getCoupons = async (
  params?: GetCouponsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Coupon[]> => {
  return customFetch<Coupon[]>(getGetCouponsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCouponsQueryKey = (params?: GetCouponsParams) => {
  return [`/api/v1/coupons`, ...(params ? [params] : [])] as const
}

export const getGetCouponsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoupons>>,
  TError = unknown,
>(
  params?: GetCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupons>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCouponsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupons>>> = ({ signal }) =>
    getCoupons(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoupons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponsQueryResult = NonNullable<Awaited<ReturnType<typeof getCoupons>>>
export type GetCouponsQueryError = unknown

export function useGetCoupons<TData = Awaited<ReturnType<typeof getCoupons>>, TError = unknown>(
  params: undefined | GetCouponsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupons>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoupons>>,
          TError,
          Awaited<ReturnType<typeof getCoupons>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoupons<TData = Awaited<ReturnType<typeof getCoupons>>, TError = unknown>(
  params?: GetCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupons>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoupons>>,
          TError,
          Awaited<ReturnType<typeof getCoupons>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoupons<TData = Awaited<ReturnType<typeof getCoupons>>, TError = unknown>(
  params?: GetCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupons>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List coupons, newest first
 */

export function useGetCoupons<TData = Awaited<ReturnType<typeof getCoupons>>, TError = unknown>(
  params?: GetCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupons>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCouponsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostCouponsUrl = () => {
  return `/api/v1/coupons`
}

/**
 * @summary Create a coupon
 */
export const postCoupons = async (
  createCouponRequest: CreateCouponRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Coupon> => {
  return customFetch<Coupon>(getPostCouponsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCouponRequest),
  })
}

export const getPostCouponsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCoupons>>,
    TError,
    { data: CreateCouponRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCoupons>>,
  TError,
  { data: CreateCouponRequest },
  TContext
> => {
  const mutationKey = ['postCoupons']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCoupons>>,
    { data: CreateCouponRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCoupons(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCouponsMutationResult = NonNullable<Awaited<ReturnType<typeof postCoupons>>>
export type PostCouponsMutationBody = CreateCouponRequest
export type PostCouponsMutationError = unknown

/**
 * @summary Create a coupon
 */
export const usePostCoupons = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCoupons>>,
      TError,
      { data: CreateCouponRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCoupons>>,
  TError,
  { data: CreateCouponRequest },
  TContext
> => {
  return useMutation(getPostCouponsMutationOptions(options), queryClient)
}
export const getPostCouponsValidateUrl = () => {
  return `/api/v1/coupons/validate`
}

/**
 * @summary Validate a coupon and calculate its discount (public)
 */
export const postCouponsValidate = async (
  validateCouponRequest: ValidateCouponRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<ValidatedCoupon> => {
  return customFetch<ValidatedCoupon>(getPostCouponsValidateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(validateCouponRequest),
  })
}

export const getPostCouponsValidateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCouponsValidate>>,
    TError,
    { data: ValidateCouponRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCouponsValidate>>,
  TError,
  { data: ValidateCouponRequest },
  TContext
> => {
  const mutationKey = ['postCouponsValidate']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCouponsValidate>>,
    { data: ValidateCouponRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCouponsValidate(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCouponsValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCouponsValidate>>
>
export type PostCouponsValidateMutationBody = ValidateCouponRequest
export type PostCouponsValidateMutationError = unknown

/**
 * @summary Validate a coupon and calculate its discount (public)
 */
export const usePostCouponsValidate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCouponsValidate>>,
      TError,
      { data: ValidateCouponRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCouponsValidate>>,
  TError,
  { data: ValidateCouponRequest },
  TContext
> => {
  return useMutation(getPostCouponsValidateMutationOptions(options), queryClient)
}
export const getGetCategoriesUrl = () => {
  return `/api/v1/categories`
}

/**
 * @summary List menu categories in display order (public - the customer site uses it)
 */
export const getCategories = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CategoryWithTranslations[]> => {
  return customFetch<CategoryWithTranslations[]>(getGetCategoriesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCategoriesQueryKey = () => {
  return [`/api/v1/categories`] as const
}

export const getGetCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCategoriesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategories>>> = ({ signal }) =>
    getCategories({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getCategories>>>
export type GetCategoriesQueryError = unknown

export function useGetCategories<
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategories<
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategories<
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List menu categories in display order (public - the customer site uses it)
 */

export function useGetCategories<
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostCategoriesUrl = () => {
  return `/api/v1/categories`
}

/**
 * @summary Create a menu category
 */
export const postCategories = async (
  createCategoryRequest: CreateCategoryRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Category> => {
  return customFetch<Category>(getPostCategoriesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCategoryRequest),
  })
}

export const getPostCategoriesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCategories>>,
    TError,
    { data: CreateCategoryRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCategories>>,
  TError,
  { data: CreateCategoryRequest },
  TContext
> => {
  const mutationKey = ['postCategories']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCategories>>,
    { data: CreateCategoryRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCategories(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof postCategories>>>
export type PostCategoriesMutationBody = CreateCategoryRequest
export type PostCategoriesMutationError = unknown

/**
 * @summary Create a menu category
 */
export const usePostCategories = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCategories>>,
      TError,
      { data: CreateCategoryRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCategories>>,
  TError,
  { data: CreateCategoryRequest },
  TContext
> => {
  return useMutation(getPostCategoriesMutationOptions(options), queryClient)
}
export const getDeleteVatCategoriesIdUrl = (id: number) => {
  return `/api/v1/vat-categories/${id}`
}

/**
 * @summary Delete a VAT category nothing is charged at
 */
export const deleteVatCategoriesId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<VatCategoryDeleted> => {
  return customFetch<VatCategoryDeleted>(getDeleteVatCategoriesIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteVatCategoriesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVatCategoriesId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVatCategoriesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteVatCategoriesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVatCategoriesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteVatCategoriesId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteVatCategoriesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVatCategoriesId>>
>

export type DeleteVatCategoriesIdMutationError = unknown

/**
 * @summary Delete a VAT category nothing is charged at
 */
export const useDeleteVatCategoriesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteVatCategoriesId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteVatCategoriesId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteVatCategoriesIdMutationOptions(options), queryClient)
}
export const getPatchVatCategoriesIdUrl = (id: number) => {
  return `/api/v1/vat-categories/${id}`
}

/**
 * @summary Change a VAT category, including its register slot
 */
export const patchVatCategoriesId = async (
  id: number,
  patchVatCategoriesIdBody: PatchVatCategoriesIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<VatCategory> => {
  return customFetch<VatCategory>(getPatchVatCategoriesIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchVatCategoriesIdBody),
  })
}

export const getPatchVatCategoriesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchVatCategoriesId>>,
    TError,
    { id: number; data: PatchVatCategoriesIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchVatCategoriesId>>,
  TError,
  { id: number; data: PatchVatCategoriesIdBody },
  TContext
> => {
  const mutationKey = ['patchVatCategoriesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchVatCategoriesId>>,
    { id: number; data: PatchVatCategoriesIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchVatCategoriesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchVatCategoriesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchVatCategoriesId>>
>
export type PatchVatCategoriesIdMutationBody = PatchVatCategoriesIdBody
export type PatchVatCategoriesIdMutationError = unknown

/**
 * @summary Change a VAT category, including its register slot
 */
export const usePatchVatCategoriesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchVatCategoriesId>>,
      TError,
      { id: number; data: PatchVatCategoriesIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchVatCategoriesId>>,
  TError,
  { id: number; data: PatchVatCategoriesIdBody },
  TContext
> => {
  return useMutation(getPatchVatCategoriesIdMutationOptions(options), queryClient)
}
export const getDeleteSurchargesIdUrl = (id: number) => {
  return `/api/v1/surcharges/${id}`
}

/**
 * @summary Delete a surcharge that has never been charged
 */
export const deleteSurchargesId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<VatCategoryDeleted> => {
  return customFetch<VatCategoryDeleted>(getDeleteSurchargesIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSurchargesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSurchargesId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSurchargesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSurchargesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSurchargesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSurchargesId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSurchargesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSurchargesId>>
>

export type DeleteSurchargesIdMutationError = unknown

/**
 * @summary Delete a surcharge that has never been charged
 */
export const useDeleteSurchargesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSurchargesId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSurchargesId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSurchargesIdMutationOptions(options), queryClient)
}
export const getPatchSurchargesIdUrl = (id: number) => {
  return `/api/v1/surcharges/${id}`
}

/**
 * @summary Change a surcharge or deposit
 */
export const patchSurchargesId = async (
  id: number,
  patchSurchargesIdBody: PatchSurchargesIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Surcharge> => {
  return customFetch<Surcharge>(getPatchSurchargesIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSurchargesIdBody),
  })
}

export const getPatchSurchargesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSurchargesId>>,
    TError,
    { id: number; data: PatchSurchargesIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSurchargesId>>,
  TError,
  { id: number; data: PatchSurchargesIdBody },
  TContext
> => {
  const mutationKey = ['patchSurchargesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSurchargesId>>,
    { id: number; data: PatchSurchargesIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSurchargesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSurchargesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSurchargesId>>
>
export type PatchSurchargesIdMutationBody = PatchSurchargesIdBody
export type PatchSurchargesIdMutationError = unknown

/**
 * @summary Change a surcharge or deposit
 */
export const usePatchSurchargesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSurchargesId>>,
      TError,
      { id: number; data: PatchSurchargesIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSurchargesId>>,
  TError,
  { id: number; data: PatchSurchargesIdBody },
  TContext
> => {
  return useMutation(getPatchSurchargesIdMutationOptions(options), queryClient)
}
export const getDeleteProductsProductIdUrl = (productId: number) => {
  return `/api/v1/products/${productId}`
}

/**
 * @summary Delete a product
 */
export const deleteProductsProductId = async (
  productId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteProductsProductIdUrl(productId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteProductsProductIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProductsProductId>>,
    TError,
    { productId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProductsProductId>>,
  TError,
  { productId: number },
  TContext
> => {
  const mutationKey = ['deleteProductsProductId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProductsProductId>>,
    { productId: number }
  > = (props) => {
    const { productId } = props ?? {}

    return deleteProductsProductId(productId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteProductsProductIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProductsProductId>>
>

export type DeleteProductsProductIdMutationError = unknown

/**
 * @summary Delete a product
 */
export const useDeleteProductsProductId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProductsProductId>>,
      TError,
      { productId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProductsProductId>>,
  TError,
  { productId: number },
  TContext
> => {
  return useMutation(getDeleteProductsProductIdMutationOptions(options), queryClient)
}
export const getPatchProductsProductIdUrl = (productId: number) => {
  return `/api/v1/products/${productId}`
}

/**
 * @summary Update a product
 */
export const patchProductsProductId = async (
  productId: number,
  patchProductsProductIdBody: PatchProductsProductIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Product> => {
  return customFetch<Product>(getPatchProductsProductIdUrl(productId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchProductsProductIdBody),
  })
}

export const getPatchProductsProductIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchProductsProductId>>,
    TError,
    { productId: number; data: PatchProductsProductIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchProductsProductId>>,
  TError,
  { productId: number; data: PatchProductsProductIdBody },
  TContext
> => {
  const mutationKey = ['patchProductsProductId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchProductsProductId>>,
    { productId: number; data: PatchProductsProductIdBody }
  > = (props) => {
    const { productId, data } = props ?? {}

    return patchProductsProductId(productId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchProductsProductIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchProductsProductId>>
>
export type PatchProductsProductIdMutationBody = PatchProductsProductIdBody
export type PatchProductsProductIdMutationError = unknown

/**
 * @summary Update a product
 */
export const usePatchProductsProductId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchProductsProductId>>,
      TError,
      { productId: number; data: PatchProductsProductIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchProductsProductId>>,
  TError,
  { productId: number; data: PatchProductsProductIdBody },
  TContext
> => {
  return useMutation(getPatchProductsProductIdMutationOptions(options), queryClient)
}
export const getDeletePizzaIngredientsIngredientIdUrl = (ingredientId: number) => {
  return `/api/v1/pizza-ingredients/${ingredientId}`
}

/**
 * @summary Delete a pizza topping
 */
export const deletePizzaIngredientsIngredientId = async (
  ingredientId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeletePizzaIngredientsIngredientIdUrl(ingredientId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeletePizzaIngredientsIngredientIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePizzaIngredientsIngredientId>>,
    TError,
    { ingredientId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePizzaIngredientsIngredientId>>,
  TError,
  { ingredientId: number },
  TContext
> => {
  const mutationKey = ['deletePizzaIngredientsIngredientId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePizzaIngredientsIngredientId>>,
    { ingredientId: number }
  > = (props) => {
    const { ingredientId } = props ?? {}

    return deletePizzaIngredientsIngredientId(ingredientId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeletePizzaIngredientsIngredientIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePizzaIngredientsIngredientId>>
>

export type DeletePizzaIngredientsIngredientIdMutationError = unknown

/**
 * @summary Delete a pizza topping
 */
export const useDeletePizzaIngredientsIngredientId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePizzaIngredientsIngredientId>>,
      TError,
      { ingredientId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePizzaIngredientsIngredientId>>,
  TError,
  { ingredientId: number },
  TContext
> => {
  return useMutation(getDeletePizzaIngredientsIngredientIdMutationOptions(options), queryClient)
}
export const getPatchPizzaIngredientsIngredientIdUrl = (ingredientId: number) => {
  return `/api/v1/pizza-ingredients/${ingredientId}`
}

/**
 * @summary Update a pizza topping
 */
export const patchPizzaIngredientsIngredientId = async (
  ingredientId: number,
  patchPizzaIngredientsIngredientIdBody: PatchPizzaIngredientsIngredientIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PizzaIngredient> => {
  return customFetch<PizzaIngredient>(getPatchPizzaIngredientsIngredientIdUrl(ingredientId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchPizzaIngredientsIngredientIdBody),
  })
}

export const getPatchPizzaIngredientsIngredientIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchPizzaIngredientsIngredientId>>,
    TError,
    { ingredientId: number; data: PatchPizzaIngredientsIngredientIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchPizzaIngredientsIngredientId>>,
  TError,
  { ingredientId: number; data: PatchPizzaIngredientsIngredientIdBody },
  TContext
> => {
  const mutationKey = ['patchPizzaIngredientsIngredientId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchPizzaIngredientsIngredientId>>,
    { ingredientId: number; data: PatchPizzaIngredientsIngredientIdBody }
  > = (props) => {
    const { ingredientId, data } = props ?? {}

    return patchPizzaIngredientsIngredientId(ingredientId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchPizzaIngredientsIngredientIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchPizzaIngredientsIngredientId>>
>
export type PatchPizzaIngredientsIngredientIdMutationBody = PatchPizzaIngredientsIngredientIdBody
export type PatchPizzaIngredientsIngredientIdMutationError = unknown

/**
 * @summary Update a pizza topping
 */
export const usePatchPizzaIngredientsIngredientId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchPizzaIngredientsIngredientId>>,
      TError,
      { ingredientId: number; data: PatchPizzaIngredientsIngredientIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchPizzaIngredientsIngredientId>>,
  TError,
  { ingredientId: number; data: PatchPizzaIngredientsIngredientIdBody },
  TContext
> => {
  return useMutation(getPatchPizzaIngredientsIngredientIdMutationOptions(options), queryClient)
}
export const getDeleteGiftsRulesRuleIdUrl = (ruleId: number) => {
  return `/api/v1/gifts/rules/${ruleId}`
}

/**
 * @summary Delete an order-total gift rule
 */
export const deleteGiftsRulesRuleId = async (
  ruleId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GiftRuleDeleted> => {
  return customFetch<GiftRuleDeleted>(getDeleteGiftsRulesRuleIdUrl(ruleId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteGiftsRulesRuleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGiftsRulesRuleId>>,
    TError,
    { ruleId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGiftsRulesRuleId>>,
  TError,
  { ruleId: number },
  TContext
> => {
  const mutationKey = ['deleteGiftsRulesRuleId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGiftsRulesRuleId>>,
    { ruleId: number }
  > = (props) => {
    const { ruleId } = props ?? {}

    return deleteGiftsRulesRuleId(ruleId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteGiftsRulesRuleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGiftsRulesRuleId>>
>

export type DeleteGiftsRulesRuleIdMutationError = unknown

/**
 * @summary Delete an order-total gift rule
 */
export const useDeleteGiftsRulesRuleId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteGiftsRulesRuleId>>,
      TError,
      { ruleId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteGiftsRulesRuleId>>,
  TError,
  { ruleId: number },
  TContext
> => {
  return useMutation(getDeleteGiftsRulesRuleIdMutationOptions(options), queryClient)
}
export const getPatchGiftsRulesRuleIdUrl = (ruleId: number) => {
  return `/api/v1/gifts/rules/${ruleId}`
}

/**
 * @summary Update an order-total gift rule
 */
export const patchGiftsRulesRuleId = async (
  ruleId: number,
  updateGiftRuleRequest: UpdateGiftRuleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<GiftRule> => {
  return customFetch<GiftRule>(getPatchGiftsRulesRuleIdUrl(ruleId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateGiftRuleRequest),
  })
}

export const getPatchGiftsRulesRuleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchGiftsRulesRuleId>>,
    TError,
    { ruleId: number; data: UpdateGiftRuleRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchGiftsRulesRuleId>>,
  TError,
  { ruleId: number; data: UpdateGiftRuleRequest },
  TContext
> => {
  const mutationKey = ['patchGiftsRulesRuleId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchGiftsRulesRuleId>>,
    { ruleId: number; data: UpdateGiftRuleRequest }
  > = (props) => {
    const { ruleId, data } = props ?? {}

    return patchGiftsRulesRuleId(ruleId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchGiftsRulesRuleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchGiftsRulesRuleId>>
>
export type PatchGiftsRulesRuleIdMutationBody = UpdateGiftRuleRequest
export type PatchGiftsRulesRuleIdMutationError = unknown

/**
 * @summary Update an order-total gift rule
 */
export const usePatchGiftsRulesRuleId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchGiftsRulesRuleId>>,
      TError,
      { ruleId: number; data: UpdateGiftRuleRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchGiftsRulesRuleId>>,
  TError,
  { ruleId: number; data: UpdateGiftRuleRequest },
  TContext
> => {
  return useMutation(getPatchGiftsRulesRuleIdMutationOptions(options), queryClient)
}
export const getDeleteGiftsProductRulesRuleIdUrl = (ruleId: number) => {
  return `/api/v1/gifts/product-rules/${ruleId}`
}

/**
 * @summary Delete a product gift rule
 */
export const deleteGiftsProductRulesRuleId = async (
  ruleId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GiftRuleDeleted> => {
  return customFetch<GiftRuleDeleted>(getDeleteGiftsProductRulesRuleIdUrl(ruleId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteGiftsProductRulesRuleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGiftsProductRulesRuleId>>,
    TError,
    { ruleId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGiftsProductRulesRuleId>>,
  TError,
  { ruleId: number },
  TContext
> => {
  const mutationKey = ['deleteGiftsProductRulesRuleId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGiftsProductRulesRuleId>>,
    { ruleId: number }
  > = (props) => {
    const { ruleId } = props ?? {}

    return deleteGiftsProductRulesRuleId(ruleId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteGiftsProductRulesRuleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGiftsProductRulesRuleId>>
>

export type DeleteGiftsProductRulesRuleIdMutationError = unknown

/**
 * @summary Delete a product gift rule
 */
export const useDeleteGiftsProductRulesRuleId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteGiftsProductRulesRuleId>>,
      TError,
      { ruleId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteGiftsProductRulesRuleId>>,
  TError,
  { ruleId: number },
  TContext
> => {
  return useMutation(getDeleteGiftsProductRulesRuleIdMutationOptions(options), queryClient)
}
export const getPatchGiftsProductRulesRuleIdUrl = (ruleId: number) => {
  return `/api/v1/gifts/product-rules/${ruleId}`
}

/**
 * @summary Update a product gift rule
 */
export const patchGiftsProductRulesRuleId = async (
  ruleId: number,
  updateProductGiftRuleRequest: UpdateProductGiftRuleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<ProductGiftRule> => {
  return customFetch<ProductGiftRule>(getPatchGiftsProductRulesRuleIdUrl(ruleId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProductGiftRuleRequest),
  })
}

export const getPatchGiftsProductRulesRuleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchGiftsProductRulesRuleId>>,
    TError,
    { ruleId: number; data: UpdateProductGiftRuleRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchGiftsProductRulesRuleId>>,
  TError,
  { ruleId: number; data: UpdateProductGiftRuleRequest },
  TContext
> => {
  const mutationKey = ['patchGiftsProductRulesRuleId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchGiftsProductRulesRuleId>>,
    { ruleId: number; data: UpdateProductGiftRuleRequest }
  > = (props) => {
    const { ruleId, data } = props ?? {}

    return patchGiftsProductRulesRuleId(ruleId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchGiftsProductRulesRuleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchGiftsProductRulesRuleId>>
>
export type PatchGiftsProductRulesRuleIdMutationBody = UpdateProductGiftRuleRequest
export type PatchGiftsProductRulesRuleIdMutationError = unknown

/**
 * @summary Update a product gift rule
 */
export const usePatchGiftsProductRulesRuleId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchGiftsProductRulesRuleId>>,
      TError,
      { ruleId: number; data: UpdateProductGiftRuleRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchGiftsProductRulesRuleId>>,
  TError,
  { ruleId: number; data: UpdateProductGiftRuleRequest },
  TContext
> => {
  return useMutation(getPatchGiftsProductRulesRuleIdMutationOptions(options), queryClient)
}
export const getDeleteDiscountPresetsPresetIdUrl = (presetId: number) => {
  return `/api/v1/discount-presets/${presetId}`
}

/**
 * @summary Delete a manual discount preset
 */
export const deleteDiscountPresetsPresetId = async (
  presetId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteDiscountPresetsPresetIdUrl(presetId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteDiscountPresetsPresetIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDiscountPresetsPresetId>>,
    TError,
    { presetId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDiscountPresetsPresetId>>,
  TError,
  { presetId: number },
  TContext
> => {
  const mutationKey = ['deleteDiscountPresetsPresetId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDiscountPresetsPresetId>>,
    { presetId: number }
  > = (props) => {
    const { presetId } = props ?? {}

    return deleteDiscountPresetsPresetId(presetId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteDiscountPresetsPresetIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDiscountPresetsPresetId>>
>

export type DeleteDiscountPresetsPresetIdMutationError = unknown

/**
 * @summary Delete a manual discount preset
 */
export const useDeleteDiscountPresetsPresetId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDiscountPresetsPresetId>>,
      TError,
      { presetId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDiscountPresetsPresetId>>,
  TError,
  { presetId: number },
  TContext
> => {
  return useMutation(getDeleteDiscountPresetsPresetIdMutationOptions(options), queryClient)
}
export const getPatchDiscountPresetsPresetIdUrl = (presetId: number) => {
  return `/api/v1/discount-presets/${presetId}`
}

/**
 * @summary Update a manual discount preset
 */
export const patchDiscountPresetsPresetId = async (
  presetId: number,
  updateDiscountPresetRequest: UpdateDiscountPresetRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<DiscountPreset> => {
  return customFetch<DiscountPreset>(getPatchDiscountPresetsPresetIdUrl(presetId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDiscountPresetRequest),
  })
}

export const getPatchDiscountPresetsPresetIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchDiscountPresetsPresetId>>,
    TError,
    { presetId: number; data: UpdateDiscountPresetRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchDiscountPresetsPresetId>>,
  TError,
  { presetId: number; data: UpdateDiscountPresetRequest },
  TContext
> => {
  const mutationKey = ['patchDiscountPresetsPresetId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchDiscountPresetsPresetId>>,
    { presetId: number; data: UpdateDiscountPresetRequest }
  > = (props) => {
    const { presetId, data } = props ?? {}

    return patchDiscountPresetsPresetId(presetId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchDiscountPresetsPresetIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchDiscountPresetsPresetId>>
>
export type PatchDiscountPresetsPresetIdMutationBody = UpdateDiscountPresetRequest
export type PatchDiscountPresetsPresetIdMutationError = unknown

/**
 * @summary Update a manual discount preset
 */
export const usePatchDiscountPresetsPresetId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchDiscountPresetsPresetId>>,
      TError,
      { presetId: number; data: UpdateDiscountPresetRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchDiscountPresetsPresetId>>,
  TError,
  { presetId: number; data: UpdateDiscountPresetRequest },
  TContext
> => {
  return useMutation(getPatchDiscountPresetsPresetIdMutationOptions(options), queryClient)
}
export const getDeleteCouponsCouponIdUrl = (couponId: number) => {
  return `/api/v1/coupons/${couponId}`
}

/**
 * @summary Delete a coupon
 */
export const deleteCouponsCouponId = async (
  couponId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteCouponsCouponIdUrl(couponId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteCouponsCouponIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCouponsCouponId>>,
    TError,
    { couponId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCouponsCouponId>>,
  TError,
  { couponId: number },
  TContext
> => {
  const mutationKey = ['deleteCouponsCouponId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCouponsCouponId>>,
    { couponId: number }
  > = (props) => {
    const { couponId } = props ?? {}

    return deleteCouponsCouponId(couponId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCouponsCouponIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCouponsCouponId>>
>

export type DeleteCouponsCouponIdMutationError = unknown

/**
 * @summary Delete a coupon
 */
export const useDeleteCouponsCouponId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCouponsCouponId>>,
      TError,
      { couponId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCouponsCouponId>>,
  TError,
  { couponId: number },
  TContext
> => {
  return useMutation(getDeleteCouponsCouponIdMutationOptions(options), queryClient)
}
export const getPatchCouponsCouponIdUrl = (couponId: number) => {
  return `/api/v1/coupons/${couponId}`
}

/**
 * @summary Update a coupon
 */
export const patchCouponsCouponId = async (
  couponId: number,
  patchCouponsCouponIdBody: PatchCouponsCouponIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Coupon> => {
  return customFetch<Coupon>(getPatchCouponsCouponIdUrl(couponId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchCouponsCouponIdBody),
  })
}

export const getPatchCouponsCouponIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCouponsCouponId>>,
    TError,
    { couponId: number; data: PatchCouponsCouponIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCouponsCouponId>>,
  TError,
  { couponId: number; data: PatchCouponsCouponIdBody },
  TContext
> => {
  const mutationKey = ['patchCouponsCouponId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCouponsCouponId>>,
    { couponId: number; data: PatchCouponsCouponIdBody }
  > = (props) => {
    const { couponId, data } = props ?? {}

    return patchCouponsCouponId(couponId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCouponsCouponIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCouponsCouponId>>
>
export type PatchCouponsCouponIdMutationBody = PatchCouponsCouponIdBody
export type PatchCouponsCouponIdMutationError = unknown

/**
 * @summary Update a coupon
 */
export const usePatchCouponsCouponId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCouponsCouponId>>,
      TError,
      { couponId: number; data: PatchCouponsCouponIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCouponsCouponId>>,
  TError,
  { couponId: number; data: PatchCouponsCouponIdBody },
  TContext
> => {
  return useMutation(getPatchCouponsCouponIdMutationOptions(options), queryClient)
}
export const getDeleteCategoriesCategoryIdUrl = (categoryId: number) => {
  return `/api/v1/categories/${categoryId}`
}

/**
 * @summary Delete a menu category
 */
export const deleteCategoriesCategoryId = async (
  categoryId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteCategoriesCategoryIdUrl(categoryId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteCategoriesCategoryIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategoriesCategoryId>>,
    TError,
    { categoryId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCategoriesCategoryId>>,
  TError,
  { categoryId: number },
  TContext
> => {
  const mutationKey = ['deleteCategoriesCategoryId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCategoriesCategoryId>>,
    { categoryId: number }
  > = (props) => {
    const { categoryId } = props ?? {}

    return deleteCategoriesCategoryId(categoryId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCategoriesCategoryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCategoriesCategoryId>>
>

export type DeleteCategoriesCategoryIdMutationError = unknown

/**
 * @summary Delete a menu category
 */
export const useDeleteCategoriesCategoryId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCategoriesCategoryId>>,
      TError,
      { categoryId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCategoriesCategoryId>>,
  TError,
  { categoryId: number },
  TContext
> => {
  return useMutation(getDeleteCategoriesCategoryIdMutationOptions(options), queryClient)
}
export const getPatchCategoriesCategoryIdUrl = (categoryId: number) => {
  return `/api/v1/categories/${categoryId}`
}

/**
 * @summary Update a menu category
 */
export const patchCategoriesCategoryId = async (
  categoryId: number,
  updateCategoryRequest: UpdateCategoryRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Category> => {
  return customFetch<Category>(getPatchCategoriesCategoryIdUrl(categoryId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCategoryRequest),
  })
}

export const getPatchCategoriesCategoryIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCategoriesCategoryId>>,
    TError,
    { categoryId: number; data: UpdateCategoryRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCategoriesCategoryId>>,
  TError,
  { categoryId: number; data: UpdateCategoryRequest },
  TContext
> => {
  const mutationKey = ['patchCategoriesCategoryId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCategoriesCategoryId>>,
    { categoryId: number; data: UpdateCategoryRequest }
  > = (props) => {
    const { categoryId, data } = props ?? {}

    return patchCategoriesCategoryId(categoryId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCategoriesCategoryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCategoriesCategoryId>>
>
export type PatchCategoriesCategoryIdMutationBody = UpdateCategoryRequest
export type PatchCategoriesCategoryIdMutationError = unknown

/**
 * @summary Update a menu category
 */
export const usePatchCategoriesCategoryId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCategoriesCategoryId>>,
      TError,
      { categoryId: number; data: UpdateCategoryRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCategoriesCategoryId>>,
  TError,
  { categoryId: number; data: UpdateCategoryRequest },
  TContext
> => {
  return useMutation(getPatchCategoriesCategoryIdMutationOptions(options), queryClient)
}
export const getGetVatConfigurationUrl = () => {
  return `/api/v1/vat/configuration`
}

/**
 * @summary The whole VAT picture - rates, the register, every channel's slot
 */
export const getVatConfiguration = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetVatConfiguration200> => {
  return customFetch<GetVatConfiguration200>(getGetVatConfigurationUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetVatConfigurationQueryKey = () => {
  return [`/api/v1/vat/configuration`] as const
}

export const getGetVatConfigurationQueryOptions = <
  TData = Awaited<ReturnType<typeof getVatConfiguration>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVatConfiguration>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetVatConfigurationQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatConfiguration>>> = ({ signal }) =>
    getVatConfiguration({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVatConfiguration>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVatConfigurationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVatConfiguration>>
>
export type GetVatConfigurationQueryError = unknown

export function useGetVatConfiguration<
  TData = Awaited<ReturnType<typeof getVatConfiguration>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVatConfiguration>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVatConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getVatConfiguration>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVatConfiguration<
  TData = Awaited<ReturnType<typeof getVatConfiguration>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVatConfiguration>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVatConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getVatConfiguration>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVatConfiguration<
  TData = Awaited<ReturnType<typeof getVatConfiguration>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVatConfiguration>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The whole VAT picture - rates, the register, every channel's slot
 */

export function useGetVatConfiguration<
  TData = Awaited<ReturnType<typeof getVatConfiguration>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVatConfiguration>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetVatConfigurationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetStockItemsListUrl = () => {
  return `/api/v1/stock-items-list`
}

/**
 * @summary Stock items a recipe ingredient can point at
 */
export const getStockItemsList = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<StockItemOption[]> => {
  return customFetch<StockItemOption[]>(getGetStockItemsListUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetStockItemsListQueryKey = () => {
  return [`/api/v1/stock-items-list`] as const
}

export const getGetStockItemsListQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockItemsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItemsList>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStockItemsListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockItemsList>>> = ({ signal }) =>
    getStockItemsList({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockItemsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockItemsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockItemsList>>
>
export type GetStockItemsListQueryError = unknown

export function useGetStockItemsList<
  TData = Awaited<ReturnType<typeof getStockItemsList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItemsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockItemsList>>,
          TError,
          Awaited<ReturnType<typeof getStockItemsList>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockItemsList<
  TData = Awaited<ReturnType<typeof getStockItemsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItemsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockItemsList>>,
          TError,
          Awaited<ReturnType<typeof getStockItemsList>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockItemsList<
  TData = Awaited<ReturnType<typeof getStockItemsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItemsList>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stock items a recipe ingredient can point at
 */

export function useGetStockItemsList<
  TData = Awaited<ReturnType<typeof getStockItemsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItemsList>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStockItemsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetRecipesByProductProductIdUrl = (productId: number) => {
  return `/api/v1/recipes/by-product/${productId}`
}

/**
 * @summary The recipe linked to a product, or null when it has none
 */
export const getRecipesByProductProductId = async (
  productId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  return customFetch<Recipe>(getGetRecipesByProductProductIdUrl(productId), {
    ...options,
    method: 'GET',
  })
}

export const getGetRecipesByProductProductIdQueryKey = (productId: number) => {
  return [`/api/v1/recipes/by-product/${productId}`] as const
}

export const getGetRecipesByProductProductIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecipesByProductProductId>>,
  TError = unknown,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecipesByProductProductId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetRecipesByProductProductIdQueryKey(productId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecipesByProductProductId>>> = ({
    signal,
  }) => getRecipesByProductProductId(productId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: productId !== null && productId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRecipesByProductProductId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetRecipesByProductProductIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecipesByProductProductId>>
>
export type GetRecipesByProductProductIdQueryError = unknown

export function useGetRecipesByProductProductId<
  TData = Awaited<ReturnType<typeof getRecipesByProductProductId>>,
  TError = unknown,
>(
  productId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecipesByProductProductId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecipesByProductProductId>>,
          TError,
          Awaited<ReturnType<typeof getRecipesByProductProductId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecipesByProductProductId<
  TData = Awaited<ReturnType<typeof getRecipesByProductProductId>>,
  TError = unknown,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecipesByProductProductId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecipesByProductProductId>>,
          TError,
          Awaited<ReturnType<typeof getRecipesByProductProductId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecipesByProductProductId<
  TData = Awaited<ReturnType<typeof getRecipesByProductProductId>>,
  TError = unknown,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecipesByProductProductId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The recipe linked to a product, or null when it has none
 */

export function useGetRecipesByProductProductId<
  TData = Awaited<ReturnType<typeof getRecipesByProductProductId>>,
  TError = unknown,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecipesByProductProductId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRecipesByProductProductIdQueryOptions(productId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetProductsCostsUrl = () => {
  return `/api/v1/products/costs`
}

/**
 * @summary Estimated cost and margin per active product
 */
export const getProductsCosts = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ProductCosts> => {
  return customFetch<ProductCosts>(getGetProductsCostsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetProductsCostsQueryKey = () => {
  return [`/api/v1/products/costs`] as const
}

export const getGetProductsCostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductsCosts>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsCosts>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProductsCostsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsCosts>>> = ({ signal }) =>
    getProductsCosts({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductsCosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsCostsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsCosts>>>
export type GetProductsCostsQueryError = unknown

export function useGetProductsCosts<
  TData = Awaited<ReturnType<typeof getProductsCosts>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsCosts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsCosts>>,
          TError,
          Awaited<ReturnType<typeof getProductsCosts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsCosts<
  TData = Awaited<ReturnType<typeof getProductsCosts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsCosts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsCosts>>,
          TError,
          Awaited<ReturnType<typeof getProductsCosts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsCosts<
  TData = Awaited<ReturnType<typeof getProductsCosts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsCosts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Estimated cost and margin per active product
 */

export function useGetProductsCosts<
  TData = Awaited<ReturnType<typeof getProductsCosts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsCosts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProductsCostsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetProductsListUrl = () => {
  return `/api/v1/products-list`
}

/**
 * @summary Products a recipe can be linked to, one per name
 */
export const getProductsList = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LinkableProduct[]> => {
  return customFetch<LinkableProduct[]>(getGetProductsListUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetProductsListQueryKey = () => {
  return [`/api/v1/products-list`] as const
}

export const getGetProductsListQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsList>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProductsListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsList>>> = ({ signal }) =>
    getProductsList({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsList>>>
export type GetProductsListQueryError = unknown

export function useGetProductsList<
  TData = Awaited<ReturnType<typeof getProductsList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsList>>,
          TError,
          Awaited<ReturnType<typeof getProductsList>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsList<
  TData = Awaited<ReturnType<typeof getProductsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsList>>,
          TError,
          Awaited<ReturnType<typeof getProductsList>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsList<
  TData = Awaited<ReturnType<typeof getProductsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsList>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Products a recipe can be linked to, one per name
 */

export function useGetProductsList<
  TData = Awaited<ReturnType<typeof getProductsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsList>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProductsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetKitchenRecipesUrl = () => {
  return `/api/v1/kitchen/recipes`
}

/**
 * @summary What each dish is made of, for the kitchen screen
 */
export const getKitchenRecipes = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<KitchenRecipe[]> => {
  return customFetch<KitchenRecipe[]>(getGetKitchenRecipesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetKitchenRecipesQueryKey = () => {
  return [`/api/v1/kitchen/recipes`] as const
}

export const getGetKitchenRecipesQueryOptions = <
  TData = Awaited<ReturnType<typeof getKitchenRecipes>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenRecipes>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetKitchenRecipesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKitchenRecipes>>> = ({ signal }) =>
    getKitchenRecipes({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getKitchenRecipes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetKitchenRecipesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKitchenRecipes>>
>
export type GetKitchenRecipesQueryError = unknown

export function useGetKitchenRecipes<
  TData = Awaited<ReturnType<typeof getKitchenRecipes>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenRecipes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKitchenRecipes>>,
          TError,
          Awaited<ReturnType<typeof getKitchenRecipes>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKitchenRecipes<
  TData = Awaited<ReturnType<typeof getKitchenRecipes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenRecipes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKitchenRecipes>>,
          TError,
          Awaited<ReturnType<typeof getKitchenRecipes>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKitchenRecipes<
  TData = Awaited<ReturnType<typeof getKitchenRecipes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenRecipes>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What each dish is made of, for the kitchen screen
 */

export function useGetKitchenRecipes<
  TData = Awaited<ReturnType<typeof getKitchenRecipes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenRecipes>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetKitchenRecipesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetGiftsProductRulesPublicUrl = () => {
  return `/api/v1/gifts/product-rules/public`
}

/**
 * @summary List active product gift rules (public - the customer site uses it)
 */
export const getGiftsProductRulesPublic = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ProductGiftRule[]> => {
  return customFetch<ProductGiftRule[]>(getGetGiftsProductRulesPublicUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetGiftsProductRulesPublicQueryKey = () => {
  return [`/api/v1/gifts/product-rules/public`] as const
}

export const getGetGiftsProductRulesPublicQueryOptions = <
  TData = Awaited<ReturnType<typeof getGiftsProductRulesPublic>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRulesPublic>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetGiftsProductRulesPublicQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGiftsProductRulesPublic>>> = ({
    signal,
  }) => getGiftsProductRulesPublic({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGiftsProductRulesPublic>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGiftsProductRulesPublicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGiftsProductRulesPublic>>
>
export type GetGiftsProductRulesPublicQueryError = unknown

export function useGetGiftsProductRulesPublic<
  TData = Awaited<ReturnType<typeof getGiftsProductRulesPublic>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRulesPublic>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGiftsProductRulesPublic>>,
          TError,
          Awaited<ReturnType<typeof getGiftsProductRulesPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGiftsProductRulesPublic<
  TData = Awaited<ReturnType<typeof getGiftsProductRulesPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRulesPublic>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGiftsProductRulesPublic>>,
          TError,
          Awaited<ReturnType<typeof getGiftsProductRulesPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGiftsProductRulesPublic<
  TData = Awaited<ReturnType<typeof getGiftsProductRulesPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRulesPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active product gift rules (public - the customer site uses it)
 */

export function useGetGiftsProductRulesPublic<
  TData = Awaited<ReturnType<typeof getGiftsProductRulesPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftsProductRulesPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGiftsProductRulesPublicQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetDiscountsStatsUrl = (params?: GetDiscountsStatsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/discounts/stats?${stringifiedParams}`
    : `/api/v1/discounts/stats`
}

/**
 * @summary Discount totals, recent manual discounts and the most-used coupons
 */
export const getDiscountsStats = async (
  params?: GetDiscountsStatsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DiscountSummary> => {
  return customFetch<DiscountSummary>(getGetDiscountsStatsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetDiscountsStatsQueryKey = (params?: GetDiscountsStatsParams) => {
  return [`/api/v1/discounts/stats`, ...(params ? [params] : [])] as const
}

export const getGetDiscountsStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiscountsStats>>,
  TError = unknown,
>(
  params?: GetDiscountsStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountsStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDiscountsStatsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscountsStats>>> = ({ signal }) =>
    getDiscountsStats(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiscountsStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDiscountsStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiscountsStats>>
>
export type GetDiscountsStatsQueryError = unknown

export function useGetDiscountsStats<
  TData = Awaited<ReturnType<typeof getDiscountsStats>>,
  TError = unknown,
>(
  params: undefined | GetDiscountsStatsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountsStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscountsStats>>,
          TError,
          Awaited<ReturnType<typeof getDiscountsStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscountsStats<
  TData = Awaited<ReturnType<typeof getDiscountsStats>>,
  TError = unknown,
>(
  params?: GetDiscountsStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountsStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscountsStats>>,
          TError,
          Awaited<ReturnType<typeof getDiscountsStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscountsStats<
  TData = Awaited<ReturnType<typeof getDiscountsStats>>,
  TError = unknown,
>(
  params?: GetDiscountsStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountsStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Discount totals, recent manual discounts and the most-used coupons
 */

export function useGetDiscountsStats<
  TData = Awaited<ReturnType<typeof getDiscountsStats>>,
  TError = unknown,
>(
  params?: GetDiscountsStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountsStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDiscountsStatsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
